import { useMemo, useRef, useState } from "react";
import { PostPerPage, stringIsEmpty } from "./common";

// Don't know why, use the experimental_useEffectEvent as the doc suggested not work. So use this polyfill.
export const useEffectEvent = (callback: any) => {
	const ref = useRef(callback);

	ref.current = callback;

	return (...args: any) => {
		ref.current(...args);
	}
}

interface PaginationDataBase {
	name: string,
	name_cht: string,
	name_chs: string,
}
export function usePagination<T extends PaginationDataBase>(data: T[], searchWord: string) {
	const [pagination, setPagination] = useState<{ count: number; page: number }>(
		{
			count: 0,
			page: 1,
		}
	);

	const paginatedDatas = useMemo(() => {
		const start = (pagination.page - 1) * PostPerPage;
		const end = start + PostPerPage;
		let pattern = new RegExp(searchWord, 'gi');
		const filteredData = stringIsEmpty(searchWord) ? data : data.filter((t => {
			return pattern.test(t.name) || pattern.test(t.name_cht) || pattern.test(t.name_chs)
		}))
		const paginatedItems = filteredData.slice(start, end);
		return paginatedItems;
	}, [data, pagination.page, searchWord]);

	const handlePaginationChange = (
		event: React.ChangeEvent<unknown>,
		page: number
	) => {
		setPagination({ ...pagination, page });
	};

	return [pagination, setPagination, paginatedDatas, handlePaginationChange] as const;
}